module.exports = __webpack_public_path__ + "img/absent.db6a5b9b.png";